<template>
    <div class="news-details">
        <div>
            <div style="font-size: 2rem;">{{newsDetailData.title}}</div>
            <div style="color: #666;margin: 1.5rem 0 2.5rem;">日期：{{newsDetailData.timePublish | formatterDate}}</div>
            <!-- <div>
                <p>{{newsDetailData.brief}}</p>
                <p>春生夏长，鹊语金日</p>
                <p>春生夏长，鹊语金日</p>
                <p>布瑞琳高端奢护店落位国门</p>
                <p>布瑞琳高端奢护店落位国门</p>
                <p>布瑞琳高端奢护店落位国门</p>
                <img src="../../assets/home.png" alt="">
                <p>被英国《卫报》评为“新世界七大奇迹之首”的大兴国际机场，是世界最大的机场，以人为本，顾客至上，承载着万千需求</p>
                <p>布瑞琳的入驻，让机场配套服务更加全场景化。</p>
                <p>被英国《卫报》评为“新世界七大奇迹之首”的大兴国际机场，是世界最大的机场，以人为本，顾客至上，承载着万千需求</p>
                <p>布瑞琳的入驻，让机场配套服务更加全场景化。</p>
                <p>被英国《卫报》评为“新世界七大奇迹之首”的大兴国际机场，是世界最大的机场，以人为本，顾客至上，承载着万千需求</p>
                <p>布瑞琳的入驻，让机场配套服务更加全场景化。</p>
                <p>被英国《卫报》评为“新世界七大奇迹之首”的大兴国际机场，是世界最大的机场，以人为本，顾客至上，承载着万千需求</p>
                <p>布瑞琳的入驻，让机场配套服务更加全场景化。</p>
                <p>被英国《卫报》评为“新世界七大奇迹之首”的大兴国际机场，是世界最大的机场，以人为本，顾客至上，承载着万千需求</p>
                <p>布瑞琳的入驻，让机场配套服务更加全场景化。</p>
                <p>被英国《卫报》评为“新世界七大奇迹之首”的大兴国际机场，是世界最大的机场，以人为本，顾客至上，承载着万千需求</p>
                <p>布瑞琳的入驻，让机场配套服务更加全场景化。</p>
            </div> -->
             <div v-html="newsDetailData.content" class="news-navs" style="text-align:left;"></div>
        </div>
    </div>
</template>

<script>
import HelloWorld from '@/components/HelloWorld.vue';
import bus from '@/components/bus';
import dayjs from 'dayjs';

export default {
  name: 'Home',
  components: {
    HelloWorld,
  },
  data(){
    return {
        newsDetailData:[],
    }
  },
  created(){
      this.$fetch('store/select/contentArticleById',{id: this.$route.params.id}).then(res => {
          console.log(res);
          this.newsDetailData = res;
      })
  },
  filters: {
    formatterDate: function (cellValue) {
      if (!cellValue) {
            return '';
        }
        return dayjs(Number(cellValue)).format('YYYY-MM-DD');
    }
  },
  mounted(){
      bus.$emit('changeRoute', this.$route.path);
  },
  methods:{

  },
  
}
</script>
<style scoped lang="scss">
.news-details{
    margin: 2rem 12rem 6rem;
    background: #fff;
    overflow: hidden;
    padding: 2rem 10rem 5rem;

    img{
        width: 100%!important;
        overflow: auto;
    }
}
.news-navs ::v-deep img{
    width: 100%!important;
    height: auto;
}
</style>